import {
  DEFAULT_4K_VIDEO_BITRATE,
  DEFAULT_VIDEO_BITRATE,
} from "../constants/constants";
import type { StreamEntitlement } from "../types/billing";
import { LiveStreamResolutionEnum } from "../types/models";

/**
 * What the builder may offer, derived only from the entitlement. The
 * `canShapes` / `canCustomElements` / `canVideoFade` DB columns are never
 * written by the api and must not be read.
 *
 * Basic runs the Streamingbots v2 worker in streamCopy mode: 1920×1080
 * horizontal (decision #1), no fades, 1 destination (decision #14).
 */
export interface BuilderCapabilities {
  canShapes: boolean;
  canCustomElements: boolean;
  canVideoFade: boolean;
  canVertical: boolean;
  maxDestinations: number;
}

export function builderCapabilities(
  entitlement: Pick<StreamEntitlement, "plan" | "features">
): BuilderCapabilities {
  const basic = entitlement.plan === "basic";
  return {
    canShapes: entitlement.features.shapes,
    canCustomElements: entitlement.features.customElements,
    canVideoFade: !basic,
    canVertical: !basic,
    maxDestinations: basic ? 1 : 3,
  };
}

/** A45: builder side-panel tabs the plan does not allow. Overlays off locks all three. */
export function lockedBuilderTabs(
  entitlement: Pick<StreamEntitlement, "plan" | "features" | "overlaysEditable">
): Array<"overlays" | "custom" | "layers"> {
  if (!entitlement.overlaysEditable) return ["overlays", "custom", "layers"];
  return builderCapabilities(entitlement).canCustomElements ? [] : ["custom"];
}

export function recommendedVideoBitrate(
  resolution: LiveStreamResolutionEnum
): number {
  return resolution === LiveStreamResolutionEnum.r2160p
    ? DEFAULT_4K_VIDEO_BITRATE
    : DEFAULT_VIDEO_BITRATE;
}
